import {Zp} from "./Zp";
import {Detail} from "./Detail";
import {Search} from "./Search";
import {SearchForm} from "./SearchForm";
import {SearchMap} from "./maps/SearchMap";
import {Stichwort} from "./Stichwort";
import {PreisRechner} from "./PreisRechner";
import {BookingRequest} from "./BookingRequest";

export class Main {
    static init() {
        const pi = window.pageInfo;
        if (pi) {
            window.Zp = Zp;
            Zp.init(pi.lang, pi.country);
            switch (pi.baseType) {
                case "detail":
                    window.Detail = Detail;
                    window.PreisRechner = PreisRechner;
                    window.Stichwort = Stichwort;
                    Detail.init();
                    Stichwort.init();
                    break;
                case "booking":
                    window.Detail = Detail;
                    window.PreisRechner = PreisRechner;
                    window.BookingRequest = BookingRequest;
                    Detail.init();
                    BookingRequest.init();
                    break;
                case "search":
                    window.Search = Search;
                    window.SearchForm = SearchForm;
                    window.SearchMap = SearchMap;
                    window.Stichwort = Stichwort;
                    Search.init();
                    Stichwort.init();
                    break;
                case "home":
                    window.Stichwort = Stichwort;
                    Stichwort.init();
                    break;
            }
        }

        //$('.set-focus:first:visible').focus().select();

        $('[data-toggle="popover"]').popover();
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="expand"]').click(function () {
            $(this).parent('.expand-container').prev(".expandable-container").toggleClass('collapsed');
            $(this).toggleClass('collapsed');
        });
        $('[data-clampedwidth]').each(function () {
            const elem = $(this);
            const parentPanel = elem.data('clampedwidth');
            const resizeFn = function () {
                const sideBarNavWidth = $(parentPanel).width() - parseInt(elem.css('paddingLeft')) - parseInt(elem.css('paddingRight')) - parseInt(elem.css('marginLeft')) - parseInt(elem.css('marginRight')) - parseInt(elem.css('borderLeftWidth')) - parseInt(elem.css('borderRightWidth'));
                elem.css('width', sideBarNavWidth);
            };
            resizeFn();
            $(window).resize(resizeFn);
        });
    }
}
